import React, { useContext, useEffect } from 'react';
import ContractModalContext from '../../context/ContractModalContext';
import ContractEditor from '../../ContractEditor';
import ContractModalFooter from '../../ContractModalFooter';

import ExternalCoachContext from '../../../../context/ExternalCoachContext';

const OneTimeContractModalContent = () => {
  const { isReadOnly, setCoachId } = useContext(ContractModalContext);

  const { externalCoachDoc: { id: coachId } } = useContext(ExternalCoachContext);

  useEffect(() => {
    if (coachId) {
      setCoachId(coachId);
    }
  }, [coachId, setCoachId]);

  return (
    <>
      <ContractEditor />
      {!isReadOnly && (<ContractModalFooter />)}
    </>
  );
};

export default OneTimeContractModalContent;
